var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReductionOfPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.6 10.3C17 8.1 17 16 21.8 15.9c4.7-.1 5.3 7.5-3.1 5.2M21.6 8.6v.7M21.6 22.2v.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32,
    cy: 2.1,
    r: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M32 7.5v18.2h6.9L21.7 40.8 4.9 25.4h6.9V2.1h14.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReductionOfPrice);
export default __webpack_public_path__ + "static/media/reductionOfPrice.d2379e4290b1d451fdd94ba6e31e73ad.svg";
export { ForwardRef as ReactComponent };